import React from 'react';

import { useRouter } from 'next/router';
import { FILTER_CODES } from '@src/containers/Filters/constants';
import { useSelector } from 'react-redux';
import { getSFUValues } from '@src/containers/Filters/selectors/getSFUValues';

const useHandleFilterDelete = () => {
	const router = useRouter();
	const sfu = useSelector(getSFUValues);
	const sfuTarget = router.pathname.replace('/[seo_slug]', '');

	const handleFilterDelete = React.useCallback(
		(item) => {
			const withSFU = { ...router.query, ...sfu };
			if (
				[FILTER_CODES.COMMON, FILTER_CODES.DISTRICT].includes(item.name)
			) {
				const newP = withSFU[item.name]
					.split(',')
					.filter((i) => i !== item.value)
					.join(',');
				const query = { ...withSFU, [item.name]: newP };
				delete query.page;
				delete query.seo_slug;

				const newRoute = {
					pathname: sfuTarget,
					query,
				};

				if (!newP) {
					delete newRoute.query[item.name];
				}

				router.push(newRoute, null, {
					shallow: false,
				});
			}
			if (item.name === FILTER_CODES.PRICE) {
				const newRoute = {
					pathname: sfuTarget,
					query: { ...withSFU },
				};

				delete newRoute.query.price;
				delete newRoute.query.page;
				delete newRoute.query.seo_slug;

				router.push(newRoute, null, {
					shallow: false,
				});
			}
		},
		[router, sfu, sfuTarget],
	);

	return { handleFilterDelete };
};

export default useHandleFilterDelete;
